import invitationapply from '@/view/invitation-apply';

const invitation = {
    install:function (Vue) {
        Vue.component('invitation',invitationapply)
    }
}
export default invitation;